var map = {
	"./MDB Pro 4.4.3/js/modules (optional)/smooth-scroll": 852
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 851;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/vendor ^\.\/MDB Pro .*\/js\/modules \(optional\)\/smooth\-scroll$
// module id = 851
// module chunks = 0